import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Form, Button, Spinner, OverlayTrigger, Tooltip, Alert } from "react-bootstrap";
import RegistrasiService from "../../services/registrasi/RegistrasiService";
import Card from "../../components/Card";
import ModalUPT from "../../views/registrasi/modal/ModalUPT";

const EditPegawai = () => {
    let nip = localStorage.getItem('username')
    const [formData, setFormData] = useState({
        NIP: "",
        NAMA: "",
        JABATAN: "",
        UNIT: "",
        KD_UNIT: "",
        STATUS: "",
        NO_REG: ""
    });

    const [loading, setLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const RegService = useMemo(() => new RegistrasiService(), []);

    //   Search UPT
    const [showUPT, setShowUPT] = useState(false);
    const handleOpenUPT = () => setShowUPT(true);
    const handleCloseUPT = () => setShowUPT(false);

    const setKodeUPT = (kode) => {
        setFormData((prev) => ({ ...prev, KD_UNIT: kode }));
    };

    const setNamaUPT = (nama) => {
        setFormData((prev) => ({ ...prev, UNIT: nama }));
    };



    useEffect(() => {
        // console.log(getLocalStorage());
        const fetchPegawai = async () => {
            try {
                const res = await RegService.getPegawai(nip);
                const { data } = res;

                setFormData({
                    ...data,
                    NO_REG: data.NO_REG || ""
                });
            } catch (error) {
                setErrorMessage("Gagal mengambil data pegawai.");
            } finally {
                setLoading(false);
            }
        };

        fetchPegawai();
    }, [nip, RegService]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage("");
        setErrorMessage("");

        try {
            await RegService.updatePegawai(nip, {
                NAMA: formData.NAMA,
                JABATAN: formData.JABATAN,
                UNIT: formData.UNIT,
                KD_UNIT: formData.KD_UNIT,
                STATUS: formData.STATUS,
                NO_REG: formData.NO_REG
            });
            setSuccessMessage("Profile berhasil diperbarui.");
        } catch (error) {
            setErrorMessage(error.message || "Gagal memperbarui data profile.");
        }
    };

    // function getLocalStorage() {
    //     const allItems = {};
    //     for (let i = 0; i < localStorage.length; i++) {
    //         const key = localStorage.key(i);
    //         allItems[key] = localStorage.getItem(key);
    //     }
    //     return allItems;
    // }

    if (loading) {
        return (
            <div className="text-center my-5">
                <Spinner animation="border" />
                <p>Memuat data pegawai...</p>
            </div>
        );
    }

    return (
        <>
            {/* Header section */}
            <Row>
                <Col md="12">
                    <div className="d-flex justify-content-between flex-wrap iq-navbar-header mb-4">
                        <div>
                            <h1 className="text-white ps-3">EDIT PROFILE</h1>
                            <h3 className="text-light ps-3">{formData.NAMA}</h3>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Form section */}
            <Card className="shadow-sm border-0 bg-light mt-5">
                <Card.Body>
                    <Form onSubmit={handleSubmit} >
                        {successMessage && <Alert variant="success">{successMessage}</Alert>}
                        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                        <Row className="mb-3">
                            <Col lg={8} md={12} className="text-start">
                                <Form.Group controlId="nip">
                                    <Form.Label>
                                        <OverlayTrigger overlay={<Tooltip>Nomor Induk Pegawai (tidak dapat diubah)</Tooltip>}>
                                            <span>NIP</span>
                                        </OverlayTrigger>
                                    </Form.Label>
                                    <Form.Control type="text" value={formData.NIP} disabled />
                                </Form.Group>
                            </Col>
                            <Col lg={8} md={12} className="text-start">
                                <Form.Group controlId="nama">
                                    <Form.Label>Nama</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="NAMA"
                                        value={formData.NAMA}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={8} md={12} className="text-start">
                                <Form.Group controlId="jabatan">
                                    <Form.Label>Jabatan</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="JABATAN"
                                        value={formData.JABATAN}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            {/* Kode Unit tetap disembunyikan */}
                            <Col lg={8} md={12} className="text-start" style={{ display: "none" }}>
                                <Form.Group controlId="kdUnit">
                                    <Form.Label>Kode Unit</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="KD_UNIT"
                                        value={formData.KD_UNIT}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            {/* Status dan Nomor Registrasi disesuaikan dengan lebar yang sama */}
                            <Col lg={8} md={12} className="text-start" style={{ display: "none" }}>
                                <Form.Group controlId="status">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        name="STATUS"
                                        value={formData.STATUS}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">-- Pilih Status --</option>
                                        <option value="0">Aktif</option>
                                        <option value="1">Non-Aktif</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col lg={8} md={12} className="text-start">
                                <Form.Group controlId="noReg">
                                    <Form.Label>Nomor Registrasi</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="NO_REG"
                                        value={formData.NO_REG}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>


                        <div className="text-center">
                            <Button variant="primary" type="submit" disabled={loading}>
                                {loading ? "Menyimpan..." : "Simpan Perubahan"}
                            </Button>
                        </div>

                        {/* ModalUPT */}
                        <ModalUPT
                            showUPT={showUPT}
                            handleCloseUPT={handleCloseUPT}
                            setKodeUPT={setKodeUPT}
                            setNamaUPT={setNamaUPT}
                        />
                    </Form>
                </Card.Body>
            </Card>
        </>
    );


};

export default EditPegawai;
